<template>
  <div
    v-if="getIsVisible"
    :style="'position: ' + getPos + '; top: ' + getPosY + 'px; left: ' + getPosX + 'px; z-index: ' + getZindex"
  >
    <v-card
      :width="getWidthWeb"
      :height="getHeightWeb"
    >
      <v-sheet
        class="pa-3"
        :style="'height: ' + getHeightWeb - 85 + 'px'"
      >
        <v-skeleton-loader
          class="mx-auto"
          type="image"
          :height="getHeightWeb - 85"
          :min-height="getHeightWeb - 85"
        />
      </v-sheet>
      <v-card-actions>
        <v-spacer />
        <v-btn
          icon
          @click="btnClick('previous')"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer />
        <v-spacer />
        <v-btn
          icon
          @click="btnClick('refresh')"
        >
          <v-icon large>mdi-refresh</v-icon>
        </v-btn>
        <v-spacer />
        <v-spacer />
        <v-btn
          icon
          @click="btnClick('home')"
        >
          <v-icon large>mdi-home</v-icon>
        </v-btn>
        <v-spacer />
        <v-spacer />
        <v-btn
          icon
          @click="btnClick('next')"
        >
          <v-icon large>mdi-chevron-right</v-icon>
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    browserWindow: {
      type: Object,
      default: () => {},
    },
    pos: {
      type: Object,
      default: () => {},
    },
    urlWeb: {
      type: String,
      default: "",
    },
    isFullscreen: {
      type: Boolean,
      default: false,
    },
    widthWeb: {
      type: Number,
      default: 0,
    },
    heightWeb: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      check: false,
      timeoutResetHome: 0,
    };
  },
  computed: {
    getZindex() {
      if (!this.isFullscreen) {
        return 500;
      } else {
        return 999;
      }
    },
    getIsVisible() {
      if (this.isFullscreen) {
        return this.check;
      } else {
        return true;
      }
    },
    getWidthWeb() {
      if (!this.isFullscreen) {
        return this.widthWeb;
      } else {
        return window.innerWidth;
      }
    },
    getHeightWeb() {
      if (!this.isFullscreen) {
        return this.heightWeb;
      } else {
        return window.innerHeight;
      }
    },
    getPos() {
      if (!this.isElectron()) {
        return "fixed";
      } else {
        return "absolute";
      }
    },
    getPosX() {
      if (!this.isFullscreen) {
        return this.pos.x;
      } else {
        return 0;
      }
    },
    getPosY() {
      if (!this.isFullscreen) {
        return this.pos.y;
      } else {
        return 0;
      }
    },
  },
  watch: {
    browserWindow: {
      immediate: true,
      handler(val) {
        if (this.isElectron()) {
          val.webContents.on("cursor-changed", () => {
            //
          });
          val.webContents.on("did-finish-load", () => {
            if (val.webContents.getURL() != this.urlWeb) {
              this.check = true;
              this.resetHome();
            }
            if (val.webContents.getURL() == this.urlWeb) {
              clearTimeout(this.timeoutResetHome);
              this.check = false;
            }
          });
        }
      },
    },
  },
  methods: {
    isElectron() {
      // Renderer process
      if (typeof window !== "undefined" && typeof window.process === "object" && window.process.type === "renderer") {
        return true;
      }

      // Main process
      if (typeof process !== "undefined" && typeof process.versions === "object" && !!process.versions.electron) {
        return true;
      }

      // Detect the user agent when the "nodeIntegration" option is set to true
      if (navigator.userAgent.indexOf() !== undefined) {
        if (
          typeof navigator === "object" &&
          typeof navigator.userAgent === "string" &&
          navigator.userAgent.indexOf("Electron") >= 0
        ) {
          return true;
        }
      }

      return false;
    },
    btnClick(name) {
      if (this.isElectron()) {
        switch (name) {
          case "home":
            this.browserWindow.webContents.loadURL(this.urlWeb);
            break;
          case "previous":
            this.browserWindow.webContents.goBack();
            break;
          case "refresh":
            this.browserWindow.reload();
            break;
          case "next":
            this.browserWindow.webContents.goForward();
            break;
          default:
            break;
        }
      }
    },
    resetHome() {
      clearTimeout(this.timeoutResetHome);
      // WE DON'T SET A NEW TIMEOUT IF ALREADY DESTROYED
      if (!this.browserWindow.isDestroyed()) {
        this.timeoutResetHome = setTimeout(() => {
          // WE DON'T TRY TO GO HOME IF ALREADY DESTROYED
          if (!this.browserWindow.isDestroyed()) {
            if (this.browserWindow.webContents !== undefined) {
              this.browserWindow.webContents.loadURL(this.urlWeb);
            }
          }
        }, 60000); // TIMER TO RESET WEB
      }
    },
  },
};
</script>

<style>
.v-skeleton-loader__image {
  height: 100%;
}
</style>
